import { render, staticRenderFns } from "./RTdonate.vue?vue&type=template&id=513c6f05&scoped=true&"
import script from "./RTdonate.vue?vue&type=script&lang=js&"
export * from "./RTdonate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c6f05",
  null
  
)

export default component.exports